import styled from "styled-components";

export const Container = styled.div`
  width: 90%;
  max-width: 1100px;
  min-height: 100vh;
  display: flex;
  padding: 40px 0;
  flex-direction: row;
  flex-wrap: wrap;

  .inputs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
  }

  hr {
    height: 2px;
    width: 100%;
    margin: 10px 0 15px;
  }

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  h2 {
    color: #000;
    font-size: 16px;
    width: 100%;
    text-align: left;
    margin: 10px 0;
  }
  h3 {
    color: #000;
    font-size: 15px;
    width: 100%;
    text-align: left;
    margin: 0 0 10px 0;
    font-weight: bold;
  }
  h4 {
    color: #000;
    width: 100%;
    margin: 0 0 5px 0;
  }

  @media (max-width: 750px) {
    padding: 30px 0;
    width: 95%;
    h1 {
      text-align: center;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }
`;

export const Setor = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  border-bottom-width: 2px;
  border-bottom-style: solid;
  border-bottom-color: #008037;
  padding: 25px 0;
  justify-content: space-between;
`;

export const Images = styled.div`
  display: flex;
  max-width: 1100px;
  width: 100%;
  margin: 5px 0 10px 0;
  flex-direction: row;
  flex-wrap: wrap;

  img {
  }

  h2 {
    color: #000;
    font-size: 18px;
    width: 100%;
    text-align: left;
    margin: 10px 0;
    font-weight: bold;
  }
`;

export const Image = styled.div`
  display: flex;
  flex-direction: column !important;
  min-width: 200px;
  max-width: 200px;
  min-height: 150px;
  align-items: center;
  margin: 10px;
  background-color: #f0f0f0;
  border-radius: 8px;

  img {
    object-fit: contain;
    width: 200px;
    max-height: 180px;
    border-radius: 8px;
  }

  h2 {
    color: #444;
    font-size: 15px;
    width: 100%;
    text-align: center;
    margin: 10px 0;
    font-weight: bold;
  }

  p {
    font-size: 12px;
    margin-top: 5px;
    width: 100%;
  }

  input {
    margin: 5px 0;
    padding: 4px;
    width: 100%;
  }
`;

export const RiskItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 15px;
  position: relative;
  margin-bottom: 15px;
  font-size: 14px;

  .risk-info {
    p {
      margin-bottom: 5px;
    }

    @media (min-width: 900px) {
      p:nth-child(-n+2) {
        max-width: 75%;
      }
    }
  }

  .risk-actions {
    display: flex;
    justify-content: flex-end;

    @media (min-width: 900px) {
      position: absolute;
      right: 15px;
      top: 15px;
    }

    button {
      margin-left: 10px;
    }
  }
`;

export const Risks = styled.div`
  display: flex;
  max-width: 1100px;
  width: 100%;
  flex-direction: column;

  h2 {
    color: #000;
    font-size: 18px;
    width: 100%;
    text-align: left;
    margin: 10px 0;
    font-weight: bold;
  }
`;

export const Risk = styled.div`
  display: flex;
  flex-direction: column !important;
  min-width: 196px;
  max-width: 196px;
  min-height: 150px;
  align-items: center;
  margin: 10px;

  h2 {
    color: #444;
    font-size: 15px;
    width: 100%;
    text-align: center;
    margin: 10px 0;
    font-weight: bold;
  }

  p {
    font-size: 12px;
    margin-top: 5px;
    width: 100%;
  }

  input {
    margin: 5px 0;
    padding: 4px;
    width: 100%;
  }
`;
